import React from "react"
import { Link } from "gatsby"
import { graphql, useStaticQuery } from "gatsby"

import Arrow from "../../common/assets/image/alpacked/authors/arrow_blog.svg"
import Container from "../../components/UI/Container"
import Heading from "../../components/Heading"
import Text from "../../components/Text"
import TitleSection from "../TitleSection"
import SectionWrapper, { Content, Photo, Section } from "./newEbook.style"

const NewEbook = () => {
  const Data = useStaticQuery(graphql`
    query {
      alpackedJson {
        EBOOK {
          info
          subtitle
          text
          items
          image {
            publicURL
          }
          button {
            text
            link
          }
        }
      }
    }
  `)

  const { EBOOK } = Data.alpackedJson

  return (
    <SectionWrapper>
      <Container width="1220px">
        <TitleSection titleA="<h2>NEW</h2>" titleB="<h2>EBOOK</h2>" />
        <Section>
          <Photo>
            <img
              loading="lazy"
              src={EBOOK.image.publicURL}
              alt="contact details"
            />
          </Photo>
          <Content>
            <div className="details">
              <div className="category-details">
                <p className="category">{EBOOK.info}</p>
                <hr className="seperator" />
              </div>
            </div>
            <div>
              <Heading as="h2" content={EBOOK.subtitle} />
              <Text content={EBOOK.text} className="introText" />
              <ul className="list-items">
                {EBOOK.items.map((item, index) => {
                  return <li key={index}>{item}</li>
                })}
              </ul>
            </div>
            <Link to={`${EBOOK.button.link}`} className="excerptLink">
              {EBOOK.button.text}
              <img loading="lazy" src={Arrow} alt="arrow" className="arrow" />
            </Link>
          </Content>
        </Section>
      </Container>
    </SectionWrapper>
  )
}

export default NewEbook
